<template>
  <el-dialog :visible.sync="dialogFormVisible" :title="titles[updateType]" :before-close="close" :close-on-click-modal="false">
    <el-form ref="form" label-width="120px" :model="initForm" :rules="rules">
      <el-form-item label="指标名称" prop="name">
        <el-input v-model="initForm.name" placeholder="请输入指标名称，不能重复添加"></el-input>
      </el-form-item>

      <el-form-item label="指标key" prop="metric">
        <el-input v-model="initForm.metric" placeholder="指标key (只能使用英文)"></el-input>
      </el-form-item>

      <el-form-item label="指标说明" prop="desc">
        <el-input type="textarea" v-model="initForm.desc" placeholder="指标说明"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button @click="$emit('close')" type="info">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    initForm: {},
    updateType: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        name: [{required: true, message: "请输入指标名称", trigger: "blur"}],
        metric: [
          {required: true, message: "请输入指标key, 例如 device.cpu.util", trigger: "blur"},
          {
            validator: (rule, value, callback) => {
              const pattern = /^[a-zA-Z0-9_.-]+$/; // 此正则表达式允许英文字母、数字、下划线、点和短横线
              if (pattern.test(value)) {
                callback(); // 如果输入匹配，验证通过
              } else {
                callback(new Error("指标key只能包含英文字母、数字、点、下划线和短横线"));
              }
            },
            trigger: "blur"
          }
        ],
        desc: [{required: false, message: "请输入指标说明", trigger: "blur"}]
      },
      titles: {
        add: "新增-设备监控指标",
        edit: "编辑-设备监控指标"
      }
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        var method = "";
        var url = "";
        var msg = "操作失败";
        var formData = {
              name: this.initForm.name,
              metric: this.initForm.metric,
              desc: this.initForm.desc
            };
        if (!valid) {alert("请检查输入是否正确！"); return false;};
        this.dialogFormVisible = false;
        if (this.updateType === "add") {
          method = "post";
          url = "device-monitor/metrics/";
          msg = "添加成功";
        } else if (this.updateType === "edit") {
          method = "patch";
          url = "device-monitor/metrics/" + this.initForm.id + "/";
          msg = "编辑成功";
        } else{
          return false;
        };
        this.$http[method](
          url,
          formData,
          () => {
            this.$baseNotice.message(msg);
            this.$emit("close");
            this.$emit("update");
          }
        )
      });
    }
  }
};
</script>
